import dynamic from 'next/dynamic';

const SaveToWishListCSR = dynamic(() => import('./index'), {
  ssr: false,
  loading: () => null
});

export default SaveToWishListCSR;
